import { render } from "./PresentationAnnouncements.vue?vue&type=template&id=0a104ce8"
import script from "./PresentationAnnouncements.vue?vue&type=script&lang=js"
export * from "./PresentationAnnouncements.vue?vue&type=script&lang=js"

import "./PresentationAnnouncements.vue?vue&type=style&index=0&id=0a104ce8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__